export enum EUniteUR1 {

    UniteCourante = 1,
    UniteOmbragee = 2,
    RiveDroite = 3,
    Chenal = 4,
    Profonde = 5,
    Unique = 6
}